import styled from 'styled-components';

export const Container = styled.section<{
  dateValue: Date | undefined;
  readOnlyInput?: boolean;
}>`
  width: 100%;
  min-width: 0;

  .react-date-picker {
    width: 100%;
    min-width: 0;

    .react-date-picker__wrapper {
      padding: 0 16px;
      height: 48px;
      min-width: 0;

      border: 1px solid #cccbcc;
      border-radius: 8px;

      background-color: #fff;

      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus-within {
        border-color: ${({ theme }) => theme.colors.orange.primary};
        box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
      }

      font-weight: 400;
      font-size: 13px;

      width: 100%;

      justify-content: space-between;

      button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 0 0 32px;
      }
      button::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: ${({ readOnlyInput }) =>
          readOnlyInput ? '100%' : '0%'} !important;
        height: ${({ readOnlyInput }) =>
          readOnlyInput ? '100%' : '0%'} !important;
        background-color: transparent;
      }

      .react-date-picker__inputGroup {
        flex: 0 1 auto;
        min-width: 0;
        max-width: 100% !important;
        padding: 0 2px;
        white-space: nowrap;

        pointer-events: ${({ readOnlyInput }) =>
          readOnlyInput ? 'none' : ''} !important;

        span,
        .react-date-picker__inputGroup__input {
          color: ${({ theme }) => theme.colors.gray[500]};
          outline: none;
        }
      }
    }

    @media (max-width: 600px) {
      .react-date-picker,
      .react-date-picker__wrapper {
        width: 100%;
        min-width: 0;
      }

      .react-date-picker .react-date-picker__wrapper {
        flex-wrap: nowrap;
        overflow: hidden;
        padding: 0 8px;
      }

      .react-date-picker .react-date-picker__inputGroup {
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        max-width: none !important;
        flex-wrap: nowrap;
        overflow: hidden;
        white-space: nowrap;
      }

      .react-date-picker .react-date-picker__wrapper button {
        flex: 0 0 32px;
        width: 32px;
      }
    }
  }

  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__month,
  .react-date-picker__inputGroup__year {
    display: ${({ dateValue }) => (!dateValue ? 'none' : null)};
  }

  .react-calendar__navigation__label__labelText {
    font-size: 14px;
    font-weight: bold;
    color: black !important;
  }

  .react-calendar__tile--now {
    background: ${({ theme }) => theme.colors.primary[70]};
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${({ theme }) => theme.colors.orange.primary};
    color: #fff;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background: ${({ theme }) => theme.colors.primary[70]};
  }
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;
